const CUSTOM_ELEMENT_NAME = "uni-applications-carousel";

class UniApplicationsCarousel extends HTMLElement {
  connectedCallback() {
    if (this._inited) return;
    this._inited = true;
    this.prevBtn = this.querySelector('[name="previous"]');
    this.nextBtn = this.querySelector('[name="next"]');
    const swiperEl = this.querySelector(".swiper");

    if (!swiperEl || typeof window.FoxTheme.Swiper.Swiper === "undefined") return;

    this._swiper = new window.FoxTheme.Swiper.Swiper(swiperEl, {
      slidesPerView: 1.5,
      spaceBetween: 16,
      speed: 500,
      grabCursor: true,
      watchOverflow: true,
      navigation: this.prevBtn && this.nextBtn ? { prevEl: this.prevBtn, nextEl: this.nextBtn } : undefined,
      breakpoints: {
        768: { slidesPerView: 3.2, spaceBetween: 32 }, // desktop: 3 e un po'
        1200: { slidesPerView: 3.3, spaceBetween: 32 }, // schermi più larghi: un filo in più
      },
      on: {
        afterInit: (s) => this._syncNavState(s, this.prevBtn, this.nextBtn),
        slideChange: (s) => this._syncNavState(s, this.prevBtn, this.nextBtn),
        reachBeginning: (s) => this._syncNavState(s, this.prevBtn, this.nextBtn),
        reachEnd: (s) => this._syncNavState(s, this.prevBtn, this.nextBtn),
        fromEdge: (s) => this._syncNavState(s, this.prevBtn, this.nextBtn),
      },
    });

    this._bindEvents();
  }

  _bindEvents() {
    this.prevBtn.addEventListener("click", (e) => {
      this._swiper.slidePrev();
    });
    this.nextBtn.addEventListener("click", (e) => {
      this._swiper.slideNext();
    });
  }

  _syncNavState(swiper) {
    if (!this.prevBtn || !this.nextBtn) return;
    this.prevBtn.disabled = !!swiper.isBeginning;
    this.nextBtn.disabled = !!swiper.isEnd;
  }

  disconnectedCallback() {
    if (this._swiper) {
      this._swiper.destroy(true, true);
      this._swiper = null;
    }
  }
}

if (!customElements.get(CUSTOM_ELEMENT_NAME)) customElements.define(CUSTOM_ELEMENT_NAME, UniApplicationsCarousel);
